<template>
  <div>
    <br />
    <!-- *******CLIENTES************ -->
    <v-container id="cliente">
      <v-row justify="center">
        <v-col cols="12" xs12 sm6 lg12>
          <v-row justify="space-around">
            <v-col cols="12" align="center">
              <v-divider></v-divider>
              <br />
              <h1 class="text mb-8">NUESTROS CLIENTES</h1>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col
          class="align-center"
          style="display: contents; zoom: 80%"
          cols="12"
          xs12
          sm8
          lg12
        >
          <div id="img" class="contenedor-empresas">
            <div v-for="image in empresasFiltradas" :key="image.id">
              <router-link
                :to="{ name: 'empresas', query: { codigo: image.id } }"
              >
                <div class="contenedor-img">
                  <img
                    style="max-height: auto; max-width: auto"
                    :src="image.url"
                    :alt="image.name"
                    class="imagenes-empresas"
                  />
                </div>
              </router-link>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-carousel cycle>
      <v-carousel-item reverse-transition="fade-transition">
        <div class="contenedor-hero">
          <div class="img-hero1">
            <div class="content-hero">
              <!-- <h3 class="texto-body-1">Sigue tu pedido de forma segura y confiable</h3> -->
              <v-row>
                <v-col cols="12" xs12 sm6 lg12>
                  <!-- <v-btn rounded outlined color="white" href="https://www.loginsa.com/">
                    visitanos
                  </v-btn> -->
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-carousel-item>
      <v-carousel-item reverse-transition="fade-transition">
        <div class="contenedor-hero">
          <div class="img-hero2">
            <div class="content-hero">
              <!-- <h3 class="texto-body-1">Tu Solo llegas más rápido, pero juntos llegamos más lejos.</h3> -->
              <v-row>
                <v-col cols="12" xs12 sm6 lg12>
                  <!-- <v-btn rounded outlined color="white" href="https://www.loginsa.com/">
                    visitanos
                  </v-btn> -->
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-carousel-item>
      <v-carousel-item reverse-transition="fade-transition">
        <div class="contenedor-hero">
          <div class="img-hero3">
            <div class="content-hero">
              <!-- <h3 class="texto-body-1">Sigue tu pedido de forma segura y confiable</h3> -->
              <v-row>
                <v-col cols="12" xs12 sm6 lg12>
                  <!-- <v-btn rounded outlined color="white" href="https://www.loginsa.com/">
                    visitanos
                  </v-btn> -->
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
    <!-- *********AYUDA********* -->
    <v-container grid-list-lg fill-height>
      <v-row justify="center">
        <v-col cols="12" xs12 sm12 lg12>
          <v-row justify="space-around">
            <v-col cols="12" align="center">
              <v-divider></v-divider>
              <br />
              <h1 class="text mb-8">COMO BUSCAR TU PEDIDO</h1>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-layout row wrap>
        <v-flex xs12 md6 lg4>
          <v-card style="border-radius: 5%; scale: 0.91">
            <v-img
              src="../assets/myCard1.jpg"
              cover
              style="
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
              "
            ></v-img>
            <v-container><v-divider></v-divider></v-container>
            <v-card-title class="justify-center"
              ><strong>Paso 1</strong></v-card-title
            >
            <v-container><v-divider></v-divider></v-container>
            <v-card-text align="center"
              >Haz click al logo que deseas Buscar la Orden.</v-card-text
            >
          </v-card>
        </v-flex>
        <v-flex xs12 md6 lg4>
          <v-card style="border-radius: 5%; scale: 0.91">
            <v-img
              src="../assets/myCard2.jpg"
              cover
              style="
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
              "
            ></v-img>
            <v-container><v-divider></v-divider></v-container>
            <v-card-title class="justify-center"
              ><strong>Paso 2</strong></v-card-title
            >
            <v-container><v-divider></v-divider></v-container>
            <v-card-text align="center"
              >Introduce el N° de Orden y da click a buscar.</v-card-text
            >
          </v-card>
        </v-flex>
        <v-flex xs12 md6 lg4>
          <v-card style="border-radius: 5%; scale: 0.91">
            <v-img
              src="../assets/myCard3.jpg"
              cover
              style="
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
              "
            ></v-img>
            <v-container><v-divider></v-divider></v-container>
            <v-card-title class="justify-center"
              ><strong>Paso 3</strong></v-card-title
            >
            <v-container><v-divider></v-divider></v-container>
            <v-card-text align="center"
              >Aparecera el Historial con Estados y Subestados.</v-card-text
            >
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import * as easings from "vuetify/es5/services/goto/easing-patterns";
export default {
  data() {
    return {
      filtro: "",
      idTest: null,
      srcTest: null,
      altTest: null,
      init: false,
      lastStatus: 1,
      idOrdenClienteFinal: null,
      tracking: false,
      valid: false,
      validId: [
        (v) => !!v || "Debes ingresar el número de búsqueda primero",
        (v) =>
          (v && v.length <= 30) || "Extensión máxima admitida de 30 caracteres",
      ],
      duration: 500,
      offset: -80,
      easing: "easeInOutCubic",
      easings: Object.keys(easings),
      texto: "azul",
      breakpoint: null,
      windowX: 0,
      windowY: 0,
    };
  },
  created() {
    if (this.theme == "light") {
      this.tcard = "tWhite";
      this.texto = "azul";
    } else if (this.theme == "dark") {
      this.tcard = "tBlack";
      this.texto = null;
    } else {
      this.tcard = "tWhite";
      this.texto = "azul";
    }
    this.setUrl(this.srcTest);
    setTimeout(() => {
      this.init = true;
      this.idOrdenClienteFinal = "";
    }, 300);
  },
  mounted() {
    this.onResize();
  },
  computed: {
    ...mapState(["loading", "theme", "imagen", "url"]),
    target() {
      const value = this[this.type];
      if (!isNaN(value)) return Number(value);
      else return value;
    },
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
    empresasFiltradas: function () {
      return this.imagen.filter((image) => {
        return image.name.toLowerCase().match(this.filtro.toLowerCase());
      });
    },
  },
  watch: {
    theme: function () {
      if (this.theme == "light") {
        this.tcard = "tWhite";
        this.texto = "azul";
      } else {
        this.tcard = "tBlack";
        this.texto = null;
      }
    },
  },
  methods: {
    ...mapMutations(["setUrl"]),
    guardarUrl() {
      this.setUrl(this.srcTest);
    },
    onResize() {
      this.windowX = window.innerWidth;
      this.windowY = window.innerHeight;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Serif&display=swap");

.contenedor-img {
  width: 7rem;
  height: 7rem;
  background-color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgb(0, 0, 0);
  border-radius: 10%;
}

.imagenes-empresas {
  width: 90%;
  cursor: pointer;
  border-radius: 5%;
}

.contenedor-empresas {
  display: grid;
  width: 1150px;
  justify-content: center;
  min-height: 300px;
  max-height: 500px;
  gap: 3rem;
  grid-auto-rows: auto;
  grid-template-columns: repeat(auto-fill, minmax(7.5rem, 1rem));
  background: rgba(0, 0, 0, 0.11);
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow-x: auto;
  padding: 1.5rem;
  margin-bottom: 20px;
}

.contenedor-empresas div:hover {
  transform: scale(1.21);
}

::-webkit-scrollbar {
  width: 1.2vh;
  border-radius: 20px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(80, 80, 80);
  border-radius: 20px;
}

.texto-1 {
  width: 50%;
  color: white;
  font-size: 30px;
  text-transform: uppercase;
  font-family: "Noto Serif", serif;
}

.text {
  font-family: "Noto Serif", serif;
}

.contenedor-hero {
  width: 100%;
  height: auto;
}

.img-hero1 {
  width: 100%;
  height: 600px;
  background-image: url("../assets/camion1.png");
  background-repeat: no-repeat;
  background-position: 0% 80%;
  background-size: cover;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
}

.img-hero2 {
  width: 80;
  height: 600px;
  background-image: url("../assets/camion2.jpg");
  background-repeat: no-repeat;
  background-position: 18% 18%;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-hero3 {
  width: 100%;
  height: 600px;
  background-image: url("../assets/camion3.jpg");
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-hero {
  width: 600px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 200px;
  margin-right: 50px;
}

.card {
  width: 450px;
  height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
  color: black !important;
  border-radius: 28px;
  background: linear-gradient(45deg, #cacaca, #f0f0f0);
  box-shadow: 29px -29px 62px #b8b8b8, -29px 29px 62px #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card h1 {
  margin-bottom: 10px;
}

.f-card {
  display: flex;
  text-align: center;
  gap: 3rem;
  flex-wrap: nowrap;
}

.img-t {
  width: 350px;
  height: 150px;
  background-size: cover;
  background-position: center;
}

@media screen and (max-width: 968px) {
  .f-card {
    display: flex;
    flex-direction: column;
  }

  .card {
    width: 350px;
  }

  .content-hero {
    width: 350px;
    margin-top: 200px;
    margin-right: 40px;
  }
}

a {
  margin: 0px;
  padding: 0px;
  line-height: 0px;
}
</style>
